import { client } from '../client';
import { normalizeCollectorUserResponse } from './normalizeCollectorUserResponse';
import { UserProfile } from './types/UserProfile';

/** GET /collector/users/{id} — detail for a managed user. For the current collector’s row use `getCurrentProfile`. */
export const getCollectorUserById = async (user_id: number): Promise<UserProfile> => {
  const { data } = await client.get(`/collector/users/${user_id}`);
  return normalizeCollectorUserResponse(data);
};

